<!--  -->
<template>
  <div>
    <div style="padding:30px">
      <div class="search_box">
        <div class="search_box">
          <el-input v-model="pageIfon.keywords" style="width:200px" placeholder="请输入员工编号/ID/名字 " />
          <el-select v-model="pageIfon.onlyMe" placeholder="请选择">
            <el-option
              v-for="item in accountarr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-select v-model="pageIfon.processing_status" placeholder="请选择">
            <el-option
              v-for="item in processingstatusarr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <!-- <el-button icon="el-icon-search" type="primary" style="margin-left:10px" @click="(pageIfon.page = 1),(resultlist())">搜索</el-button> -->
          <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
          <el-button icon="el-icon-refresh-left" type="info" style="max-height:37px" @click="reset">重置</el-button>
        </div>
        <div>
          <!-- <el-button type="success" icon="el-icon-plus" @click="add()">新增</el-button> -->
        </div>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
      >
        <!-- <el-table-column
          prop="keyword"
          label="关键词"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <div class="daertw">{{ scope.row.keyword }}</div>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="keyword"
          label="关键词"
          align="center"
          width="300"
        >
          <template slot-scope="scope">
            <el-popover
              placement="top-start"
              title="关键词"
              width="300"
              trigger="hover"
              :content="scope.row.keyword"
            >
              <div slot="reference" class="sedrtw">{{ scope.row.keyword }}</div>
            </el-popover>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="corp_name"
          label="公司名称"
          width="180"
          align="center"
        /> -->
        <el-table-column
          prop="name"
          label="员工名称(公司名称)"
          width="230"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.name }}({{ scope.row.corp_name }})
          </template>
        </el-table-column>
        <el-table-column
          prop="employee_no"
          label="员工编号"
          width="200"
          align="center"
        />
        <el-table-column
          prop="external_user_name"
          label="客户名称"
          align="center"
          width="150"
        />
        <el-table-column
          prop="name"
          label="客户头像"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <img :src="scope.row.external_user_avatar" style="width:50px;" alt="" srcset="">
          </template>
        </el-table-column>
        <el-table-column
          prop="status_text"
          label="状态"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <i v-if="scope.row.status_text === '已经处理'" class="el-icon-success" style="color:#67c23a" />
            <i v-if="scope.row.status_text === '不处理'" class="el-icon-error" style="color:#f56c6c" />
            {{ scope.row.status_text }}
          </template>
        </el-table-column>
        <el-table-column
          prop="created_time_text"
          label="创建时间"
          width="160"
          align="center"
        />
        <el-table-column
          prop="processing_time_text"
          label="处理时间"
          width="160"
          align="center"
        />
        <el-table-column
          prop="address"
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="primary" size="mini" :disabled="scope.row.friend_id == ''" @click="contactcustomers(scope.row)">联系客户</el-button>
            <el-button type="warning" size="mini" :disabled="scope.row.processing_status == 2" @click="edit(scope.row)">修改处理结果</el-button>
            <el-button type="success" size="mini" @click="looklistr(scope.row.id)">查看后续记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
    <el-dialog
      title="私聊"
      :visible.sync="privatechatdialog"
      :append-to-body="true"
      :destroy-on-close="true"
      @closed="closed"
    >
      <!-- :destroy-on-close="true" -->
      <div
        v-loading="privatechatdialogloading"
        class="qr_box"
        element-loading-background="transparent"
      >
        <privatechat ref="privatechatview" />
      </div>
    </el-dialog>
    <el-dialog
      title="处理结果"
      :visible.sync="addstatusdialogr"
      :destroy-on-close="true"
      class="fullscreen"
      :append-to-body="true"
    >
      <!-- :destroy-on-close="true" -->
      <div>
        <addstatusdialog ref="addstatusdialogview" @updata="updata" />
      </div>
    </el-dialog>
    <el-dialog
      title="投诉后续记录"
      :visible.sync="complaintdialog"
      :destroy-on-close="true"
      class="fullscreen"
      :append-to-body="true"
      width="40%"
    >
      <!-- :destroy-on-close="true" -->
      <div>
        <complainsrtdialog ref="complainsrtdialogview" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import privatechat from '../enterpriseAstaff/components/privatechat.vue'
// import privatechat from './components/privatechat.vue'
import PaginationRight from '@/components/PaginationRight/index.vue'
import addstatusdialog from './components/addstatusdialog.vue'
import complainsrtdialog from './components/complainsrtdialog.vue'
import { keywordCollectindex } from '@/api/officialaccount.js'
export default {
  name: 'Keywordslist',
  components: { privatechat, PaginationRight, addstatusdialog, complainsrtdialog },
  data() {
    return {
      privatechatdialog: false,
      privatechatdialogloading: false,
      total: null,
      pageIfon: {
        page: 1,
        page_size: 10,
        keywords: null,
        processing_status: 0,
        onlyMe: 2,
        pid: 0
      },
      accountarr: [{
        value: 1,
        label: '查看组内消息'
      }, {
        value: 2,
        label: '我关联的消息'
      }],
      processingstatusarr: [{
        value: 0,
        label: '全部状态'
      }, {
        value: 1,
        label: '未处理'
      }, {
        value: 2,
        label: '已经处理'
      }, {
        value: 3,
        label: '不处理'
      }],
      tableData: [],
      loading: false,
      addstatusdialogr: false,
      complaintdialog: false
    }
  },
  created() {
    this.resultlist()
  },
  mounted() {

  },
  methods: {
    closed() {
      console.log('111')
      this.$nextTick(() => {
        this.$refs.privatechatview.close()
      })
    },
    async resultlist() {
      this.loading = true
      const data = await keywordCollectindex(this.pageIfon)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
      console.log('data', data)
    },
    contactcustomers(item) {
      console.log(item)
      this.privatechatdialog = true
      this.$nextTick(() => {
        this.$refs.privatechatview.sendr(item, 2, 1)
      })
    },
    search() {
      this.pageIfon.page = 1
      this.resultlist()
    },
    reset() {
      this.pageIfon.page = 1
      this.pageIfon.keywords = null
      this.pageIfon.processing_status = 0
      this.pageIfon.onlyMe = 2
      this.resultlist()
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.resultlist()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.resultlist()
    },
    edit(item) {
      this.addstatusdialogr = true
      this.$nextTick(() => {
        this.$refs.addstatusdialogview.send(item)
      })
    },
    updata() {
      this.addstatusdialogr = false
      this.resultlist()
    },
    looklistr(id) {
      this.complaintdialog = true
      this.$nextTick(() => {
        this.$refs.complainsrtdialogview.send(id)
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.search_box{
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    margin-bottom:10px
  }
  .daertw{
    width: 100px;
    margin: 0 auto;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .sedrtw{
    width: 280px;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin: 0 auto;
}
</style>
